import React, { useState } from 'react';
import styled from 'styled-components';
import { useCookies } from 'react-cookie';
import { Avatar, Dropdown, MenuProps } from 'antd';
import { theme } from 'utils/style/theme';
import { cookieServices } from 'services/cookieServices';
import accountIcon from 'utils/icon/icon_account-black.svg';
import phoneIcon from 'utils/icon/icon_phone-black.svg';
import logoutIcon from 'utils/icon/icon_logout-black.svg';
import arrowUpIcon from 'utils/icon/icon_arrow-up-black.svg';
import arrowDownIcon from 'utils/icon/icon_arrow-down-black.svg';

/**
 * * 유저명, 메일 주소, 로그아웃 버튼 출력
 */

interface IProps {
  onClick: (e: any) => void;
}
const UserInfoBox = ({ onClick }: IProps) => {
  const [cookie] = useCookies();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const user = cookieServices.getUserInfo();
  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <ItemWrapper>
          <img src={accountIcon} alt='Account' />
          <p className='text'>Account</p>
        </ItemWrapper>
      ),
    },
    {
      key: '2',
      label: (
        <ItemWrapper>
          <img src={phoneIcon} alt='Phone' />
          <p className='text'>Contact us</p>
        </ItemWrapper>
      ),
    },
    {
      key: '3',
      label: (
        <ItemWrapper onClick={onClick}>
          <img src={logoutIcon} alt='logout' />
          <p className='text'>Log out</p>
        </ItemWrapper>
      ),
    },
  ];
  return (
    <div>
      <DropdownWrapper
        menu={{ items }}
        overlayStyle={{ width: '143px' }}
        onOpenChange={(open) => setIsOpen(open)}
      >
        <div>
          <Avatar style={{ backgroundColor: '#d7e4ff' }}>
            <UserName>{user?.email?.slice(0, 1)?.toUpperCase()}</UserName>
          </Avatar>{' '}
          <img src={isOpen ? arrowUpIcon : arrowDownIcon} alt={'arrow'} />
        </div>
      </DropdownWrapper>
    </div>
  );
};

export default UserInfoBox;

const DropdownWrapper = styled(Dropdown)`
  .ant-dropdown ul {
    & > * + * {
      margin-top: 16px;
    }
  }
`;

const UserName = styled.span`
  color: #05205e;
  font-size: ${theme.fontSizes.sm};
  font-style: normal;
  font-weight: ${theme.fontWeights.medium};
  line-height: 20px; /* 166.667% */
  letter-spacing: 0.2px;
`;

const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  & > * + * {
    margin-left: 8px;
  }
  .text {
    font-size: ${theme.fontSizes.sm};
    font-style: normal;
    font-weight: ${theme.fontWeights.medium};
    line-height: 24px;
    letter-spacing: 0.2px;
  }
`;
